// The app uses a single shared login (one business, one device-set of staff).
// We model it as one Firebase Authentication user whose password IS the PIN.
//
// The email below is a fixed, non-secret identifier for that single account —
// the staff never type it. They only enter the 6-digit PIN, which we use as the
// password for `signInWithEmailAndPassword`. This gives us REAL authentication
// (the database rules require `auth != null`) while keeping the familiar
// PIN-only experience.
//
// One-time setup (see SECURITY_SETUP.md):
//   1. Enable the Email/Password provider in the Firebase Console.
//   2. Create a user with this exact email and a 6-digit password (the PIN).
export const AUTH_EMAIL = "linos-app@isidoros-linos.web.app";

// Firebase requires passwords of at least 6 characters, so the PIN is 6 digits.
export const PIN_LENGTH = 6;
